import React from 'react';

import classes from '../Logout/Logout.css';
import DisplayBox from '../../hoc/DisplayBox/DisplayBox';

const error = (props) => (
    <div className={classes.Logout}>
        <DisplayBox>
            <p>{props.message}</p>
        </DisplayBox>
    </div>
);

export default error;